import { Controller } from "@hotwired/stimulus";

// Drives the landing page's statement previews. All five cards read one shared
// mode off this element's data-mode, so they crossfade in unison — that is what
// makes the section read as a single demo rather than five widgets.
//
// State lives in data attributes rather than the instance so the markup can set
// the starting mode and Tailwind can style every layer with group-data-[…]
// variants. The controller only owns the timer.
export default class extends Controller {
  static values = { interval: { type: Number, default: 4200 } };

  connect() {
    // Auto-playing a crossfade is motion nobody asked for; leave it paused.
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.dataset.auto = "false";
      return;
    }

    this.start();
  }

  disconnect() {
    this.stop();
  }

  // A deliberate choice wins: pick a mode and the carousel stops.
  select(event) {
    this.element.dataset.mode = event.params.mode;
    this.pause();
  }

  // Any deliberate interaction inside the section pauses it — the bucket
  // presets in the Age Analysis preview call this alongside their own action.
  pause() {
    this.element.dataset.auto = "false";
    this.stop();
  }

  toggle() {
    if (this.playing) {
      this.pause();
    } else {
      this.element.dataset.auto = "true";
      this.start();
    }
  }

  get playing() {
    return this.element.dataset.auto === "true";
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.flip(), this.intervalValue);
  }

  stop() {
    if (!this.timer) return;

    clearInterval(this.timer);
    this.timer = null;
  }

  // Bubbles to window as `preview-mode:flip`, which the Age Analysis preview
  // listens for so its bucket presets advance on the same clock.
  flip() {
    this.element.dataset.mode = this.element.dataset.mode === "example" ? "vars" : "example";
    this.dispatch("flip");
  }
}
